/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formfields_Dropdown_Search1Inputs */

const en_formfields_dropdown_search1 = /** @type {(inputs: Formfields_Dropdown_Search1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search...`)
};

/**
* | output |
* | --- |
* | "Search..." |
*
* @param {Formfields_Dropdown_Search1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const formfields_dropdown_search1 = /** @type {((inputs?: Formfields_Dropdown_Search1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formfields_Dropdown_Search1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_formfields_dropdown_search1(inputs)
});
export { formfields_dropdown_search1 as "formFields_dropdown_search" }